import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
// import { AntPath } from "react-leaflet-ant-path";
import { Select, Card, Row, Col, Tag, Statistic } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import AnimatedAntPath from "./AnimatedAntPath";

// ---- Live Price Ticker ----
const commoditiesInit = [
    { name: "Pineapple", price: 800 },
    { name: "Sesame", price: 1200 },
    { name: "Fertilizer", price: 420 },
    { name: "Maize", price: 350 },
];

const LivePriceTicker = () => {
    const [prices, setPrices] = useState(commoditiesInit);

    useEffect(() => {
        const interval = setInterval(() => {
            setPrices(prev =>
                prev.map(item => ({
                    ...item,
                    price: item.price + (Math.random() * 20 - 10), // simulate market move
                }))
            );
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            background: "#1c1c1c",
            padding: "6px 10px",
            color: "#fff",
            fontSize: "14px",
            borderRadius: "6px",
            marginBottom: "10px"
        }}>
            <div style={{
                display: "inline-block",
                animation: "ticker 15s linear infinite"
            }}>
                {prices.map((item, i) => (
                    <span key={i} style={{ marginRight: "40px" }}>
            {item.name}: <Tag color={item.price > commoditiesInit[i].price ? "green" : "red"}>
              €{item.price.toFixed(2)}
            </Tag>
          </span>
                ))}
            </div>
            <style>
                {`
          @keyframes ticker {
            0% { transform: translateX(100%); }
            100% { transform: translateX(-100%); }
          }
        `}
            </style>
        </div>
    );
};

// ---- Trade Data ----
const tradeData = [
    { type: "export", from: [6.1725, 1.2314], to: [46.6034, 1.8883], product: "Pineapple", category: "Fresh Produce", region: "Europe", price: "€800/T", status: "Active" },
    { type: "export", from: [6.1725, 1.2314], to: [20.5937, 78.9629], product: "Sesame Seeds", category: "Grains", region: "Asia", price: "€1,200/T", status: "Negotiation" },
    { type: "import", from: [6.1725, 1.2314], to: [31.7917, -7.0926], product: "NPK Fertilizer", category: "Inputs", region: "Africa", price: "€420/T", status: "Completed" },
    { type: "import", from: [6.1725, 1.2314], to: [35.8617, 104.1954], product: "Solar Pump", category: "Technology", region: "Asia", price: "€1,200/unit", status: "Active" },
];

const HeroPremiumDashboard = () => {
    const heroCoords = [6.1725, 1.2314];
    const [filters, setFilters] = useState({ category: "All", region: "All", status: "All" });

    const filteredData = tradeData.filter(item =>
        (filters.category === "All" || item.category === filters.category) &&
        (filters.region === "All" || item.region === filters.region) &&
        (filters.status === "All" || item.status === filters.status)
    );

    return (
        <div style={{ backgroundColor: "#0f0f0f", padding: "20px", borderRadius: "12px", color: "#fff" }}>

            {/* Live Price Ticker */}
            <LivePriceTicker />

            {/* KPI Cards */}
            <Row gutter={16} style={{ marginBottom: "15px" }}>
                <Col span={8}>
                    <Card style={{ backgroundColor: "#1c1c1c" }}>
                        <Statistic title="Export Volume" value={1200} suffix="T" valueStyle={{ color: "#3f8600" }} prefix={<ArrowUpOutlined />} />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card style={{ backgroundColor: "#1c1c1c" }}>
                        <Statistic title="Import Volume" value={800} suffix="T" valueStyle={{ color: "#1890ff" }} prefix={<ArrowDownOutlined />} />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card style={{ backgroundColor: "#1c1c1c" }}>
                        <Statistic title="Active Deals" value={5} valueStyle={{ color: "#ffc107" }} />
                    </Card>
                </Col>
            </Row>

            {/* Filters */}
            <Row gutter={8} style={{ marginBottom: "10px" }}>
                <Col span={8}>
                    <Select value={filters.category} onChange={v => setFilters({...filters, category: v})} style={{ width: "100%" }}>
                        <Select.Option value="All">All Categories</Select.Option>
                        <Select.Option value="Fresh Produce">Fresh Produce</Select.Option>
                        <Select.Option value="Grains">Grains</Select.Option>
                        <Select.Option value="Inputs">Inputs</Select.Option>
                        <Select.Option value="Technology">Technology</Select.Option>
                    </Select>
                </Col>
                <Col span={8}>
                    <Select value={filters.region} onChange={v => setFilters({...filters, region: v})} style={{ width: "100%" }}>
                        <Select.Option value="All">All Regions</Select.Option>
                        <Select.Option value="Africa">Africa</Select.Option>
                        <Select.Option value="Europe">Europe</Select.Option>
                        <Select.Option value="Asia">Asia</Select.Option>
                        <Select.Option value="Americas">Americas</Select.Option>
                    </Select>
                </Col>
                <Col span={8}>
                    <Select value={filters.status} onChange={v => setFilters({...filters, status: v})} style={{ width: "100%" }}>
                        <Select.Option value="All">All Status</Select.Option>
                        <Select.Option value="Active">Active</Select.Option>
                        <Select.Option value="Negotiation">Negotiation</Select.Option>
                        <Select.Option value="Completed">Completed</Select.Option>
                    </Select>
                </Col>
            </Row>

            {/* Map & Opportunities */}
            <Row gutter={16}>
                <Col span={16}>
                    <div style={{ height: "550px", borderRadius: "12px", overflow: "hidden" }}>
                        <MapContainer center={heroCoords} zoom={2} style={{ height: "100%", width: "100%" }}>
                            <TileLayer
                                url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                            />

                            {filteredData.map((route, i) => (
                                <React.Fragment key={`route-${i}`}>
                                    <AnimatedAntPath
                                        positions={[route.from, route.to]}
                                        options={{
                                            color: route.type === "export" ? "lime" : "cyan",
                                            weight: 4,
                                            opacity: 0.7,
                                            dashArray: [10, 20],
                                            pulseColor: '#FFFFFF'
                                        }}
                                    />
                                    <Marker position={route.to}>
                                        <Popup>
                                            <Card size="small" title={route.product}>
                                                <p><b>Category:</b> {route.category}</p>
                                                <p><b>Price:</b> {route.price}</p>
                                                <Tag color={route.status === "Active" ? "green" : route.status === "Negotiation" ? "orange" : "blue"}>
                                                    {route.status}
                                                </Tag>
                                            </Card>
                                        </Popup>
                                    </Marker>
                                </React.Fragment>
                            ))}
                        </MapContainer>
                    </div>
                </Col>

                {/* Top Opportunities */}
                <Col span={8}>
                    <Card title="Top Opportunities" style={{ backgroundColor: "#1c1c1c", height: "550px", overflowY: "auto" }}>
                        {filteredData.map((deal, i) => (
                            <Card
                                key={`deal-${i}`}
                                size="small"
                                style={{ marginBottom: "8px", backgroundColor: "#2c2c2c", color: "#fff" }}
                            >
                                <b>{deal.product}</b> → {deal.region}
                                <p style={{ margin: 0, fontSize: "12px" }}>Price: {deal.price}</p>
                                <Tag color={deal.status === "Active" ? "green" : deal.status === "Negotiation" ? "orange" : "blue"}>
                                    {deal.status}
                                </Tag>
                            </Card>
                        ))}
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default HeroPremiumDashboard;
